/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import TEXT from "../../../../utils/globalText"
import OwnerAccViewAll from "../../../../containers/Accounts/OwnerAccount/OwnerAccountViewAll";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

const OwnerAccountPopUp = ({
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  setOpenOwner,
  flow,
  TypeAccount,
  BenEnableNextButton,
  onAccountSelect,
  handleButtonClick,
  accountNumber,
  accountnumberstate,
  setaccountnumberstate,
  multiSelect,
  setAccountNumber,
  onClosed,
  setDefaultAccountNumber,
  accountDefaultNumber,
  popType,
  handlePopupClose,
  scheduleIntenralTxn,
  setRefactorAccDetail,
  type,
  setpaymentBox,
  selectedLabelsCreate,
  TypeRTGS,
  currentAccountDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);
  const handleButtonClickLocal = (dataItem) => {
    onAccountSelect?.(
      dataItem?.name?.trim(),
      dataItem?.bank_acc_no?.trim(),
      dataItem?.ifsc_code?.trim(),
      dataItem?.id?.trim(),
    );
  };
  const handleButtonClickToUse =
    flow === "ReimbursementRequestMultiFlow" && handleButtonClick
      ? handleButtonClick
      : handleButtonClickLocal;

  const headerTitle = useMemo(() => {
    if (flow === "internalTxn") {
      return TEXT?.SELECT_DESTINATION_ACCOUNT;
    }

    if (TypeAccount === "InternalAccountTxn") {
      return TEXT?.SELECT_OWNER_ACCOUNT;
    }

    return TEXT?.SELECT_OWNER_ACCOUNT;
  }, [flow, TypeAccount]);

  const headersubtext = useMemo(() => {
    if (flow === "ReimbursementRequestMultiFlow") {
      return TEXT?.ONLY_CONNECTED_BANKING_NOTE;
    }
    if (flow === "internalTxn") {
      return TEXT?.ONLY_ACTIVE_ACCOUNTS_SELECTABLE;
    }

    if (TypeAccount === "InternalAccountTxn" || type === TEXT?.BULK_STATEMENT) {
      return TEXT?.ONLY_ACTIVE_CONNECTED_BANKING_NOTE;
    }
    if (multiSelect) {
      return TEXT?.SELECT_ACCOUNTS_FOR_CONSOLIDATION;
    }

    return "";
  }, [flow, TypeAccount, type]);

  const handleClosePopup = () => {
    setOpenOwner?.(false);
  };

  return (
    <LargePopupRedirect
      closeiconhandleFunction={handleClosePopup}
      isfullViewrequired={false}
      fullviewbtnText={TEXT?.OPEN_IN_FULL_VIEW}
      fullviewhandleFunction={() => {
        handleClosePopup();
        navigate("/owner_account_dashboard/owner_accounts_view_all");
      }}
      fullviewicon={ICONS?.REDIRECT}
      isbottomSectionneed={false}
      headerTitle={headerTitle}
      headersubtext={headersubtext}
    >
      <OwnerAccViewAll
        typepop="popup"
        setOpenOwner={setOpenOwner}
        setIsNeft={setIsNeft}
        setIsImps={setIsImps}
        setIsRtgs={setIsRtgs}
        txnPayLoad={txnPayLoad}
        setTxnPayLoad={setTxnPayLoad}
        flow={
          flow === "ReimbursementRequestMultiFlow"
            ? "ReimbursementRequestMultiFlow"
            : "createTxn"
        }
        handleButtonClick={handleButtonClickToUse}
        BenEnableNextButton={BenEnableNextButton}
        owneraccountNumber={accountNumber}
        setownerAccountNumber={setAccountNumber}
        owneraccountnumberstate={accountnumberstate}
        setowneraccountnumberstate={setaccountnumberstate}
        multiSelect={multiSelect}
        onClosed={onClosed}
        setDefaultAccountNumber={setDefaultAccountNumber}
        TypeAccount={TypeAccount}
        owneraccountDefaultNumber={accountDefaultNumber}
        popType={popType}
        handlePopupClose={handlePopupClose}
        scheduleIntenralTxn={scheduleIntenralTxn}
        type={type}
        setpaymentBox={setpaymentBox}
        setRefactorAccDetail={setRefactorAccDetail}
        selectedLabelsCreate={selectedLabelsCreate}
        TypeRTGS={TypeRTGS}
        currentAccountDetails={currentAccountDetails}
      />
    </LargePopupRedirect>
  );
};

export default OwnerAccountPopUp;
